import { elementVersions } from "../config/form_builder/index";

export const getElementComponentLastVersion = elementName => {
  const element = elementVersions[elementName];
  return element.lastVersion;
};

export const getElementComponentConfig = elementName => {
  const element = elementVersions[elementName];
  return element;
};

export const getElementComponentData = (elementName, elementVersion) => {
  const element = elementVersions[elementName];
  if (!elementVersion) elementVersion = element.lastVersion;
  const version = element.versions[elementVersion];
  return version;
};

export const getElementComponents = () => {
  const components = Object.keys(elementVersions)
    .filter(element => {
      return elementVersions[element].type == "component";
    })
    .map(element => ({
      ...elementVersions[element],
      elType: element
    }));
  return components;
};

export const getElementComponentLayoutProperties = (
  elementName,
  elementVersion
) => {
  const element = elementVersions[elementName];
  return element.versionLayoutProperties
    ? element.versionLayoutProperties[elementVersion]
    : [];
};

const getElementIndex = (elementId, elementType) => {
  return parseInt(elementId.substr(elementType.length), 10);
};

const getElementsLastIndex = json => {
  let elementsLastIndex = {};
  for (let rowIndex = 0; rowIndex < json.rows.length; rowIndex++) {
    const row = json.rows[rowIndex];
    if (!elementsLastIndex["Row"])
      elementsLastIndex["Row"] = getElementIndex(row.id, "Row");
    else if (getElementIndex(row.id, "Row") > elementsLastIndex["Row"])
      elementsLastIndex["Row"] = getElementIndex(row.id, "Row");
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (!elementsLastIndex["Column"])
        elementsLastIndex["Column"] = getElementIndex(column.id, "Column");
      else if (
        getElementIndex(column.id, "Column") > elementsLastIndex["Column"]
      )
        elementsLastIndex["Column"] = getElementIndex(column.id, "Column");
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (!elementsLastIndex[component.elType])
            elementsLastIndex[component.elType] = getElementIndex(
              component.id,
              component.elType
            );
          else if (
            getElementIndex(component.id, component.elType) >
            elementsLastIndex[component.elType]
          )
            elementsLastIndex[component.elType] = getElementIndex(
              component.id,
              component.elType
            );

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let index = 0;
            index < componentLayoutProperties.length;
            index++
          ) {
            const layoutProperty = componentLayoutProperties[index];
            const layoutElementsLastIndex = getElementsLastIndex(
              component.properties[layoutProperty]
            );
            const layoutlayoutElementsLastIndexTypes = Object.keys(
              layoutElementsLastIndex
            );
            for (
              let index = 0;
              index < layoutlayoutElementsLastIndexTypes.length;
              index++
            ) {
              const layoutlayoutElementsLastIndexType =
                layoutlayoutElementsLastIndexTypes[index];
              if (!elementsLastIndex[layoutlayoutElementsLastIndexType])
                elementsLastIndex[layoutlayoutElementsLastIndexType] =
                  layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
              else if (
                layoutElementsLastIndex[layoutlayoutElementsLastIndexType] >
                elementsLastIndex[layoutlayoutElementsLastIndexType]
              )
                elementsLastIndex[layoutlayoutElementsLastIndexType] =
                  layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
            }
          }
        }
      }
      if (column.layout) {
        const layoutElementsLastIndex = getElementsLastIndex(column.layout);
        const layoutlayoutElementsLastIndexTypes = Object.keys(
          layoutElementsLastIndex
        );
        for (
          let index = 0;
          index < layoutlayoutElementsLastIndexTypes.length;
          index++
        ) {
          const layoutlayoutElementsLastIndexType =
            layoutlayoutElementsLastIndexTypes[index];
          if (!elementsLastIndex[layoutlayoutElementsLastIndexType])
            elementsLastIndex[layoutlayoutElementsLastIndexType] =
              layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
          else if (
            layoutElementsLastIndex[layoutlayoutElementsLastIndexType] >
            elementsLastIndex[layoutlayoutElementsLastIndexType]
          )
            elementsLastIndex[layoutlayoutElementsLastIndexType] =
              layoutElementsLastIndex[layoutlayoutElementsLastIndexType];
        }
      }
    }
  }
  return elementsLastIndex;
};

export const getElementUniqueId = (json, elementType) => {
  const elementsLastIndex = getElementsLastIndex(json);
  return (
    elementType +
    (elementsLastIndex[elementType] ? elementsLastIndex[elementType] + 1 : 1)
  );
};

export const getElementFromId = (json, elementId) => {
  if (json.id == elementId.id) return json;
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (row.id == elementId) return row;
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.id == elementId) return column;
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (component.id == elementId) return component;

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutElement = getElementFromId(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              elementId
            );
            if (layoutElement) return layoutElement;
          }
        }
      }
      if (column.layout) {
        const layoutElement = getElementFromId({ ...column }, elementId);
        if (layoutElement) return layoutElement;
      }
    }
  }
  return null;
};

export const getFormBuilderComponents = json => {
  let components = [];
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        components = [...components, ...column.components];
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            components = [
              ...components,
              ...getFormBuilderComponents({
                id: component.id,
                layout: component.properties[layoutProperty]
              })
            ];
          }
        }
      }

      if (column.layout) {
        components = [
          ...components,
          ...getFormBuilderComponents({ ...column })
        ];
      }
    }
  }
  return components;
};

export const getFormBuilderSelectedElement = (
  json,
  selectedElementControlId
) => {
  if (json.id == selectedElementControlId) return json;
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (row.id == selectedElementControlId) return row;
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.id == selectedElementControlId) return column;
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (component.id == selectedElementControlId) return component;

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutSelectedElement = getFormBuilderSelectedElement(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              selectedElementControlId
            );
            if (layoutSelectedElement) return layoutSelectedElement;
          }
        }
      }
      if (column.layout) {
        const layoutSelectedElement = getFormBuilderSelectedElement(
          column,
          selectedElementControlId
        );
        if (layoutSelectedElement) return layoutSelectedElement;
      }
    }
  }
  return null;
};

export const setFormBuilderSelectedElement = (json, newSelectedElement) => {
  if (json.id == newSelectedElement.id) json = newSelectedElement;
  else {
    for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
      const row = json.layout.rows[rowIndex];
      if (row.id == newSelectedElement.id)
        json.layout.rows[rowIndex] = newSelectedElement;
      for (
        let columnIndex = 0;
        columnIndex < row.columns.length;
        columnIndex++
      ) {
        const column = row.columns[columnIndex];
        if (column.id == newSelectedElement.id)
          row.columns[columnIndex] = newSelectedElement;
        if (column.components) {
          for (
            let componentIndex = 0;
            componentIndex < column.components.length;
            componentIndex++
          ) {
            const component = column.components[componentIndex];
            if (component.id == newSelectedElement.id)
              column.components[componentIndex] = newSelectedElement;
            else {
              const componentLayoutProperties = getElementComponentLayoutProperties(
                component.elType,
                component.version
              );
              for (
                let componentLayoutIndex = 0;
                componentLayoutIndex < componentLayoutProperties.length;
                componentLayoutIndex++
              ) {
                const layoutProperty =
                  componentLayoutProperties[componentLayoutIndex];
                const layoutJson = setFormBuilderSelectedElement(
                  {
                    id: component.id,
                    layout: component.properties[layoutProperty]
                  },
                  newSelectedElement
                );
                row.columns[columnIndex].components[componentIndex].properties[
                  layoutProperty
                ] = layoutJson.layout;
              }
            }
          }
        }
        if (column.layout) {
          const layoutJson = setFormBuilderSelectedElement(
            { ...column },
            newSelectedElement
          );
          row.columns[columnIndex] = layoutJson;
        }
      }
    }
  }
  return json;
};

export const removeFormBuilderMovingComponent = (json, movingComponentId) => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutJson = removeFormBuilderMovingComponent(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              movingComponentId
            );
            row.columns[columnIndex].components[componentIndex].properties[
              layoutProperty
            ] = layoutJson.layout;
          }
          if (component.id == movingComponentId) {
            column.components.splice(componentIndex, 1);
          }
        }
      }
      if (column.layout) {
        const layoutJson = removeFormBuilderMovingComponent(
          { ...column },
          movingComponentId
        );
        row.columns[columnIndex] = layoutJson;
      }
    }
  }
  return json;
};

export const removeFormBuilderEmptySpaces = json => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (column.components) {
        if (
          json.layout.rows[rowIndex].columns[columnIndex].components.length == 0
        ) {
          json.layout.rows[rowIndex].columns.splice(columnIndex, 1);
          columnIndex--;
        } else {
          for (
            let componentIndex = 0;
            componentIndex < column.components.length;
            componentIndex++
          ) {
            const component = column.components[componentIndex];

            const componentLayoutProperties = getElementComponentLayoutProperties(
              component.elType,
              component.version
            );
            for (
              let componentLayoutIndex = 0;
              componentLayoutIndex < componentLayoutProperties.length;
              componentLayoutIndex++
            ) {
              const layoutProperty =
                componentLayoutProperties[componentLayoutIndex];
              const layoutJson = removeFormBuilderEmptySpaces({
                id: component.id,
                layout: component.properties[layoutProperty]
              });
              row.columns[columnIndex].components[componentIndex].properties[
                layoutProperty
              ] = layoutJson.layout;
            }
          }
        }
      }
      if (column.layout) {
        const layoutJson = removeFormBuilderEmptySpaces({ ...column });
        row.columns[columnIndex] = layoutJson;
      }
    }
    if (json.layout.rows[rowIndex].columns.length == 0) {
      json.layout.rows.splice(rowIndex, 1);
      rowIndex--;
    }
  }
  return json;
};

export const getFormJsonBaked = (json, computedProperties) => {
  for (let rowIndex = 0; rowIndex < json.layout.rows.length; rowIndex++) {
    const row = json.layout.rows[rowIndex];
    if (computedProperties[row.id])
      json.layout.rows[rowIndex].properties = {
        ...json.layout.rows[rowIndex].properties,
        ...computedProperties[row.id]
      };
    for (let columnIndex = 0; columnIndex < row.columns.length; columnIndex++) {
      const column = row.columns[columnIndex];
      if (computedProperties[column.id])
        json.layout.rows[rowIndex].columns[columnIndex].properties = {
          ...json.layout.rows[rowIndex].columns[columnIndex].properties,
          ...computedProperties[column.id]
        };
      if (column.components) {
        for (
          let componentIndex = 0;
          componentIndex < column.components.length;
          componentIndex++
        ) {
          const component = column.components[componentIndex];
          if (computedProperties[component.id])
            json.layout.rows[rowIndex].columns[columnIndex].components[
              componentIndex
            ].properties = {
              ...json.layout.rows[rowIndex].columns[columnIndex].components[
                componentIndex
              ].properties,
              ...computedProperties[component.id]
            };

          const componentLayoutProperties = getElementComponentLayoutProperties(
            component.elType,
            component.version
          );
          for (
            let componentLayoutIndex = 0;
            componentLayoutIndex < componentLayoutProperties.length;
            componentLayoutIndex++
          ) {
            const layoutProperty =
              componentLayoutProperties[componentLayoutIndex];
            const layoutJson = getFormJsonBaked(
              {
                id: component.id,
                layout: component.properties[layoutProperty]
              },
              computedProperties
            );
            row.columns[columnIndex].components[componentIndex].properties[
              layoutProperty
            ] = layoutJson.layout;
          }
        }
      }
      if (column.layout) {
        const layoutJson = getFormJsonBaked({ ...column }, computedProperties);
        row.columns[columnIndex] = layoutJson;
      }
    }
  }
  return json;
};

export const valueOrOther = value => {
  if (!value) return "";
  if (value.value == "Other") return value.otherValue;
  return value.value;
};
